module.exports = "/_next/static/images/dd77155f8f20b61827b1c054ab755cf3-nubanker-ds@2x.jpg.webp";